import { render, staticRenderFns } from "./content-dialog-field.vue?vue&type=template&id=58ef3589"
import script from "./content-dialog-field.vue?vue&type=script&lang=js"
export * from "./content-dialog-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports